import StageFilesTree from './StageFilesTree.component';

export default StageFilesTree;
